// extracted by mini-css-extract-plugin
module.exports = {"confirmBtn":"contentDialogConfirm_confirmBtn__3YVj0"};